import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';
import useSWR from 'swr'

export default function useAuthCurrentUser() {
  //const result = useSWR('getCurrentUser', getCurrentUser);
  const result = useSWR('fetchUserAttributes', fetchUserAttributes);
  
  
  return result
}